import { useState } from "react";
import HttpClient from "../utils/HttpClient";

const MemberVideoDocumentUpdateModal = ({ closemodal, data, setData, updateForm, setSaveEditedData }) => {
  const [formData, setFormData] = useState(data);
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState({});
  const initDoc = {
    "docName": "",
    "pdf": "",
    "fileName": ""
  }
  const [isUploading, setIsUploading] = useState(false);

  const validate = () => {
    let isValid = true;
    const error = {};

    if (!formData?.videoUrl) {
      error.videoUrl = "Please enter video URL";
      isValid = false;
    }

    setErrors(error);
    return isValid;
  };

  const submit = () => {
    if (validate()) {
      setData({
        ...data,
        ...formData,
      });
      setSaveEditedData(true);
      closemodal();
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleDocumentName = (e, i) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newData = [...prev.doc];
      newData[i] = { ...newData[i], [name]: value };
      return { ...prev, doc: newData };
    });
  }

  const handleDocument = async (e, i) => {
    let formData = new FormData()
    const file = e.target.files[0];
    if (!file) return;
    // Validate file type
    const validFileTypes = ["application/pdf"];
    if (!validFileTypes.includes(file.type)) {
      setErrors(prev => ({ ...prev, [`pdf_${i}`]: "Error: Please upload a valid PDF file" }));
      return;
    }

    // Validate file size (3MB = 3145728 bytes)
    const maxSize = 3 * 1024 * 1024;
    if (file.size > maxSize) {
      setErrors(prev => ({ ...prev, [`pdf_${i}`]: "Error: File size must be less than or equal to 3MB" }));
      return;
    }
    setIsUploading(true);

    setSelectedFile(prev => ({ ...prev, [`pdf_${i}`]: file?.name || '' }));
    formData.append("document", e.target.files[0])
    const res = await HttpClient.fileUplode("document-upload", "POST", formData);
    if (res && res.status) {
      setFormData((prevData) => {
        const newDocData = [...prevData.doc];
        newDocData[i] = { ...newDocData[i], pdf: res.data.url, fileName: file?.name || '' };
        return { ...prevData, doc: newDocData };
      });
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`pdf_${i}`];
        return newErrors;
      });
      setIsUploading(false);
    } else {
      setIsUploading(false);
      setErrors(prev => ({ ...prev, [`pdf_${i}`]: res?.message || "Error uploading file" }));
    }
  }

  const handleAddMore = () => {
    const newData = [...formData.doc, { ...initDoc }];
    setFormData(prev => ({ ...prev, doc: newData }));
  }

  return (

    <div className="uploabannermodalbgshadow">
      <div className="compamyinfoeditbgmain">
        <h5 className="mt-2 p-0 m-3">Update Profile</h5>
        <hr />
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="eidutcommhifnnfodivdibvamain">
          {/* <div className="modal-form-container">
            <div className="compamydinfodivmain">

              <div className="compamydinfodivmainbtm">
                <p className="conattaindptxtppnewallasa">
                  Video URL <span>*</span>
                </p>
                <input
                  type="text"
                  placeholder="Video URL"
                  className="inpustxocntbusuitxtppnewallattyy"
                  value={formData?.videoUrl || ""}
                  onChange={(e) =>
                    handleInputChange("videoUrl", e.target.value)
                  }
                />
                {errors.videoUrl && (
                  <span className="error">{errors.videoUrl}</span>
                )}
              </div>
            </div>
          </div> */}

          <div className="eidutcommhifnnfodiv mt-2">
            <p><strong>PDF Profile</strong></p>
            <div className="compamydinfodivmain">
              {formData?.doc?.map((item, i) => {
                return (<>
                  <div className="compamydinfodivmainbtm border p-4 mt-2 bg-light" key={i}>
                    <p className="conattaindptxtppnewallasa">Profile Name</p>
                    <input
                      type="text"
                      className="mt-1 form-control"
                      name="docName"
                      value={item?.docName}
                      onChange={(e) => handleDocumentName(e, i)}
                    />

                    <p className="conattaindptxtppnewallasa mt-2">Profile File</p>
                    <input
                      key={i}
                      type="file"
                      className="mt-1 "
                      name="pdf"
                      accept=".pdf"
                      onChange={(e) => handleDocument(e, i)}
                    />
                    {isUploading && <span className="text-info">Uploading...</span>}
                    <div className="mt-2" style={{ color: '#6c757d' }}><em>Only PDF files are allowed, Maximum file size 3MB </em></div>
                    <span className="float-right cursor-pointer" onClick={() => {
                      const newData = formData.doc?.filter((ele, ind) => i !== ind)
                      setFormData(prev => ({ ...prev, doc: newData }))
                    }}> <i className="fa fa-trash" /> </span>

                    {item?.pdf && (
                      <a href={item?.pdf} target="_blank" rel="noopener noreferrer" download="" className='text-primary mt-2'>
                        Open PDF <i className="fa-solid fa-download"></i>
                      </a>
                    )}

                  </div>
                  {errors[`pdf_${i}`] && (
                    <span className="error">{errors[`pdf_${i}`]}</span>
                  )}
                </>);
              })}
            </div>
            <span onClick={handleAddMore}><i className="fa fa-plus border p-2 mt-2"></i></span>
          </div>

          <div className="eidutcommhifnnfodiv mt-2">
            <div className="svavtatvvbtnnmddsupscftt">
              <button
                className="svavtatvvbtnnm"
                onClick={() => {
                  submit();
                }}
              >
                Save
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
export default MemberVideoDocumentUpdateModal;
